import validationMixin from '../utils/validationMixin'
import simpleInputWrapper from '../utils/simpleInputWrapper'
import textFieldMixin from '@/agilis/components/Form/utils/textFieldMixin.js'

export default {
  name: 'FormText',
  mixins: [simpleInputWrapper, validationMixin, textFieldMixin]
}
